/* global axios */
import ApiClient from '../ApiClient';

// Opções de tabulação (T-97/R1.23): categorias e tipos de atendimento da taxonomia oficial.
// Vem do backend, e não de uma lista no front, para não existirem duas verdades.
class TabulacaoAPI extends ApiClient {
  constructor() {
    super('fandata/tabulacao', { accountScoped: true });
  }

  opcoes() {
    return axios.get(this.url);
  }
}

export default new TabulacaoAPI();
